import { Movement } from 'components/movement-indicator/movement-indicator.component';
import { GuestJourneyStageGrid } from '../guest-journey-reports.types';

/**
 * The 9 segment names in canonical `SPEND_TIER_x_VISIT_TIER_y` order
 * (spend-major, tier1→tier3). The BE ships these display-ready as each grid
 * cell's `PulseKpiCard.title`; fixtures reuse them across tabs.
 */
export const SEGMENT_NAMES = [
  'Value Explorer',
  'Value Regular',
  'Value Superfan',
  'Core Explorer',
  'Core Regular',
  'Core Superfan',
  'Indulgent Explorer',
  'Indulgent Regular',
  'Indulgent Superfan',
];

const SEGMENT_MOVEMENTS: Movement[] = [
  { text: 'Moving Down', direction: 'DOWN_LEFT' },
  { text: 'Stable', direction: 'STABLE' },
  { text: 'Moving Down', direction: 'DOWN_LEFT' },
  { text: 'Moving Down', direction: 'DOWN_LEFT' },
  { text: 'Moving Up', direction: 'UP_RIGHT' },
  { text: 'Stable', direction: 'STABLE' },
  { text: 'Moving Up', direction: 'UP_RIGHT' },
  { text: 'Moving Up', direction: 'UP_RIGHT' },
  { text: 'Stable', direction: 'STABLE' },
];

/**
 * Builds one metric grid of display-ready cells from canonical-order value
 * strings (already BE-formatted: counts, `$` spend, visits).
 */
export const buildStageGrid = (
  values: string[],
): GuestJourneyStageGrid['countGrid'] => ({
  cells: SEGMENT_NAMES.map((title, i) => ({
    title,
    value: values[i],
    trend: SEGMENT_MOVEMENTS[i],
  })),
});
